import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigurableGridComponent, GridConfig } from '../configurable-grid/configurable-grid.component';
import { MasterDataService } from '../../../Services/master-data.service';
import { BaseInspectionOverview } from 'src/app/DTOs/InspectionMasterData/productDetailModel';

@Component({
  selector: 'app-requirements',
  standalone: true,
  imports: [CommonModule, ConfigurableGridComponent],
  templateUrl: './requirements.component.html',
  styleUrl: './requirements.component.css'
})
export class RequirementsComponent {
  gridConfig: GridConfig;

  constructor(private masterData: MasterDataService) {
    this.gridConfig = {
      getData: () => this.masterData.getRequirementsOverview(),
      createItem: (item: BaseInspectionOverview) => this.masterData.createRequirements(item),
      updateItem: (id: number, item: BaseInspectionOverview) => this.masterData.updateRequirements(item.databaseId, item),
      deleteItem: (id: number) => this.masterData.deleteRequirement(id)
    };
  }
}
